<!--
  - Copyright (c) 2019 brightlamp
  -->

<template>
    <v-container >
        <v-row align="center" justify="center">
            <v-col xs="12" sm="6" md="4">
                <v-img :src="require('../assets/images/logo b text.svg')" alt="Logo" width="192" class="mb-2"/>
                <router-view/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: 'anonymous'
    };
</script>